import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import styled from 'styled-components';
import styles from './ImageGallery.style';
import ImageTextCard from '../../molecules/ImageTextCard';
import Anchor from '../../atoms/Anchor';
import componentAnalytics from '../../../constants/analyticsConstants';
var ImageGalleryBlock = styled.section.withConfig({
  componentId: "sc-x37jpm-0"
})(["", ";"], styles);
var ImageGallery = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageGallery, _React$Component);
  var _super = _createSuper(ImageGallery);
  function ImageGallery(props) {
    var _this;
    _classCallCheck(this, ImageGallery);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onSelectIndex", function (index) {
      _this.props.onSelectTile(index);
    });
    _this.onSelectIndex = _this.onSelectIndex.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ImageGallery, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        tileData = _this$props.tileData,
        index = _this$props.index,
        srcSetSetting = _this$props.srcSetSetting;
      if (!tileData) {
        return null;
      }
      return __jsx(ImageGalleryBlock, {
        className: "nva-image-gallery__tile gallery-tile"
      }, __jsx(Anchor, {
        className: "nva-image-gallery__anchor",
        title: tileData.altText || 'Image Gallery Tile',
        to: "#",
        "data-analytics-type": componentAnalytics.gallery.analyticsType.GALLERY_CARD,
        "data-analytics-value": tileData.title,
        "data-analytics-variation": "",
        onClick: function onClick() {
          return _this2.onSelectIndex(index);
        }
      }, __jsx(ImageTextCard, {
        className: "nva-image-gallery__text-card",
        styleType: "gallery",
        ariaLabel: tileData.title,
        headingText: tileData.title,
        headingType: "h3",
        key: index,
        imageSource: tileData.imgSrc,
        imageAltText: tileData.altText,
        imageTitle: tileData.title || tileData.altText,
        mediaType: tileData.mediaType,
        imageClassName: "nva-image-gallery__text-card-image ".concat(tileData.appliedClass),
        headingClassName: "nva-image-gallery__text-card-heading gallery-heading heading_four",
        srcSetSetting: srcSetSetting
      })));
    }
  }]);
  return ImageGallery;
}(React.Component);
ImageGallery.defaultProps = {
  galleryData: '',
  className: ''
};
export default styled(ImageGallery).withConfig({
  componentId: "sc-x37jpm-1"
})(["", ";"], styles);
export { ImageGallery as ImageGalleryVanilla };